// Vue
import { mixins } from "vue-class-component";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Interfaces
import { TableRowActionOptions } from "../../../interfaces/TableRowActionOptions";
import { TableColumnOptions } from "../../../interfaces/TableColumnOptions";

// Mixins
import { EventBus } from "./../../../mixins/event_bus/EventBus";

// Components
import { Icon } from "../icon/Icon";
import { TableCol } from "./col/TableCol";
import { TableRowCell } from "./row/cell/TableRowCell";
import { TableRowActions } from "./row/actions/TableRowActions";

@Component({
  name: "Table",
  components: {
    Icon,
    TableCol,
    TableRowCell,
    TableRowActions,
  },
  mixins: [template],
})
export class Table extends mixins(EventBus) {
  // public get sortedData() {
  //
  //     return this.data.map(row => row).sort((a, b) => {
  //         if (!this.sortBy)
  //             return 0
  //
  //         if (a[this.sortBy] < b[this.sortBy])
  //             return this.sortOrder === 'ASC' ? -1 : 1;
  //
  //         if (a[this.sortBy] > b[this.sortBy])
  //             return this.sortOrder === 'ASC' ? 1 : -1;
  //
  //         return 0;
  //     })
  // }

  // Sorting
  public sortBy: string = "";
  public sortOrder: string = "";

  // Pagination
  public currentPage: number = 1;

  // Expanded rows
  public internalExpandedRows: number[] = [];

  @Prop({ default: "default" })
  public theme!: string;

  @Prop({ type: [Object, Array] })
  public data!: any[];

  @Prop()
  public cols!: { [key: string]: TableColumnOptions };

  @Prop()
  public actions!: string[];

  @Prop({ default: () => [] })
  public expandedRows!: number[];

  @Prop({ default: () => [] })
  public disabledRows!: number[];

  @Prop({ default: "" })
  public defaultSortBy!: string;

  @Prop({ default: "ASC" })
  public defaultSortOrder!: string;

  @Prop({ default: () => [] })
  public disabledExpandRows!: number[];

  @Watch("expandedRows")
  private watchExpandedRows(newExpandedRows) {
    if (JSON.stringify(newExpandedRows.concat().sort()) != JSON.stringify(this.internalExpandedRows.concat().sort())) {
      this.internalExpandedRows = newExpandedRows;
    }
  }

  @Watch("defaultSortBy")
  private watchDefaultSortBy(newDefaultSortBy) {
    if (newDefaultSortBy != this.sortBy) {
      this.sortBy = this.defaultSortBy;
      this.handleSort(this.sortBy);
    }
  }

  @Watch("defaultSortOrder")
  private watchDefaultSortOrder(newDefaultSortOrder) {
    if (newDefaultSortOrder != this.sortOrder) {
      this.sortOrder = this.defaultSortOrder;
      this.handleSort(this.sortBy);
    }
  }

  public created() {
    this.$on("internalSort", this.handleSort);

    this.internalExpandedRows = this.expandedRows;
    this.sortBy = this.defaultSortBy;
    this.sortOrder = this.defaultSortOrder;
  }

  public destroyed() {
    this.$off("internalSort", this.handleSort);
  }

  // public handleSort(sortBy: string) {
  //     if (this.sortBy === sortBy) {
  //         this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC'
  //     } else {
  //         this.sortBy = sortBy
  //         this.sortOrder = 'ASC'
  //     }
  // }

  public handleSort(sortBy: string) {
    if (this.sortBy === sortBy) {
      this.sortOrder = this.sortOrder === "ASC" ? "DESC" : "ASC";

      this.$emit("sort", { sortBy: this.sortBy, sortOrder: this.sortOrder });
    } else {
      this.sortBy = sortBy;
      this.sortOrder = "ASC";
      this.$emit("sort", { sortBy: this.sortBy, sortOrder: this.sortOrder });
    }
  }

  public handleToggleRow(rowKey: number) {
    if (this.internalExpandedRows.indexOf(rowKey) !== -1) {
      this.internalExpandedRows.splice(this.internalExpandedRows.indexOf(rowKey), 1);
    } else {
      this.internalExpandedRows.push(rowKey);
    }

    this.$emit("update:expandedRows", this.internalExpandedRows);
  }

  public handleRowClick(rowKey: number, event) {
    if (!this.$scopedSlots["row-expand"] && !this.disabledRows.includes(rowKey)) {
      this.$emit("rowClick", rowKey, event);
    } else {
      this.handleToggleRow(rowKey);
    }
  }
}
